import {onFind} from "@elements/init-modules-in-scope";
import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init();

import * as priceTable from './scripts/price-table.js';
priceTable.init();

import * as calcRoute from './scripts/calculate-route.js';
calcRoute.init();

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    new Popover(element);
});

import * as lazyIframe from '@elements/lazy-iframe';
lazyIframe.init();

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();

import * as ajaxAccordion from './scripts/ajax-accordion';
ajaxAccordion.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as passwordStrength from './scripts/password-strength';
passwordStrength.init();

import * as passwordRepeat from './scripts/password-repeat';
passwordRepeat.init();

import * as fileInput from './scripts/file-input';
fileInput.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as fancySelect from './scripts/fancy-select';
fancySelect.init();

import * as checkoutCart from './scripts/checkout-cart';
checkoutCart.init();

import * as cartEntries from './scripts/cart-entries';
cartEntries.init();